//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.wintermar.inspection.graphql.DeleteInspectionMutation
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object DeleteInspectionMutation_ResponseAdapter {
  public object Data : Adapter<DeleteInspectionMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("deleteInspection")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): DeleteInspectionMutation.Data {
      var _deleteInspection: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _deleteInspection = AnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return DeleteInspectionMutation.Data(
        deleteInspection = _deleteInspection ?: missingField(reader, "deleteInspection")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: DeleteInspectionMutation.Data,
    ) {
      writer.name("deleteInspection")
      AnyAdapter.toJson(writer, customScalarAdapters, value.deleteInspection)
    }
  }
}
